import {useApiEndpoint} from "../../../../../lib/HttpService";
import {PATH} from "./const";
import { StubbornRouter } from "../../../../../application/business/StubbornRouter";

export const useEditionRouterApi = () => useApiEndpoint<StubbornRouter>(PATH);
